<template>
    <transition name="fade-in-up">
        <router-view></router-view>
    </transition>
</template>
<script>
export default {
    name: "setting-page-layout"
}
</script>

<style scoped>

</style>
